import { createApi } from '@reduxjs/toolkit/query/react';

import {
  Entitlement,
  EntitlementsResponse,
} from 'src/interfaces/entitlement.types';
import { baseQuery } from 'src/store/redux';

export const retailApi = createApi({
  reducerPath: 'retail',
  baseQuery: baseQuery('retail'),
  endpoints: (builder) => ({
    getMyClassEntitlements: builder.query<Entitlement[], void>({
      query: () => `my/class/assets`,
      transformResponse: (response: EntitlementsResponse) =>
        response?.entitlement ?? [],
    }),
  }),
});

export const { useGetMyClassEntitlementsQuery } = retailApi;
